import ServiciosGenericos from 'servicios/ServiciosGenericos';
import { solicitud_de_sso  } from 'servicios/Api';

export default class ServiciosDeSSOUsuario extends ServiciosGenericos{
    constructor(moduleName){
        super(moduleName,solicitud_de_sso);
    }
}